module.exports = __webpack_public_path__ + "static/media/cronimet.eadd63e5.png";